import {
  HaulerActions,
  LOAD,
  LOAD_COMPLETE,
  SET,
  LOAD_INITIAL_STATE,
  RESET,
} from '../../actions/hauler-actions/hauler.actions';
import { IHauler } from '@cemex-core/cmx-api/models/hauler';
import { ILocationConfigUnit } from '../../models/location-config.interface';

export interface IHaulerState {
  loaded: boolean;
  loading: boolean;
  haulers: IHauler[];
  required: boolean;
  disabled: boolean;
  visible: boolean;
  selected: IHauler;
}

export const initialState: IHaulerState = {
  required: false,
  disabled: false,
  visible: false,
  loaded: false,
  loading: false,
  haulers: [],
  selected: null,
};

export function haulerReducer(state = initialState, action: HaulerActions): IHaulerState {
  switch (action.type) {
    case LOAD_INITIAL_STATE: {
      if (action.payload) {
        const haulerInitialState: ILocationConfigUnit = action.payload;
        return {
          ...state,
          disabled: haulerInitialState.disabled,
          required: haulerInitialState.required,
          visible: haulerInitialState.visible,
        } as IHaulerState;
      }
      return {
        ...initialState,
      };
    }
    case LOAD: {
      return {
        ...state,
        loading: true,
      };
    }
    case LOAD_COMPLETE: {
      const haulers: IHauler[] = action.payload.haulers;
      return {
        ...state,
        loaded: true,
        loading: false,
        haulers: haulers,
      } as IHaulerState;
    }
    case SET: {
      const hauler: IHauler = action.payload;
      return {
        ...state,
        selected: hauler,
      } as IHaulerState;
    }
    case RESET: {
      return {
        ...initialState,
      };
    }
    default: {
      return state;
    }
  }
}
